module.exports = __webpack_public_path__ + "static/media/transferwise.498ce0bd.svg";